export enum Side {
  Left = 10,
  Right = 30
}
